import {
  Bell,
  BookHeart,
  ChartSpline,
  CircleUser,
  CreditCard,
  type LucideIcon,
  MessagesSquare,
  MonitorSmartphone,
  Settings2,
  SlidersHorizontal,
} from "lucide-react";

export type NavItem = { title: string; href: string; icon: LucideIcon };

// The left nav is about the child/device; everything about the parent's own
// account lives in the account menu. Layout design: TZ-471. Consumed by
// app-sidebar.tsx and console-header.tsx (titles derive from this table).
export const CONSOLE_TABS: NavItem[] = [
  { title: "Chat history", href: "/", icon: MessagesSquare },
  { title: "Insights", href: "/insights", icon: ChartSpline },
  { title: "Controls", href: "/controls", icon: SlidersHorizontal },
  { title: "Memory", href: "/memory", icon: BookHeart },
];

// Rendered by both the account menu (nav-user.tsx) and the settings tab
// strip (settings-nav.tsx), so the two can't drift apart. Security lives
// under Account (password today; 2FA and sessions land there too) — not a
// section of its own.
export const SETTINGS_SECTIONS: NavItem[] = [
  { title: "General", href: "/settings/general", icon: Settings2 },
  { title: "Account", href: "/settings/account", icon: CircleUser },
  { title: "Devices", href: "/settings/devices", icon: MonitorSmartphone },
  { title: "Notifications", href: "/settings/notifications", icon: Bell },
  { title: "Plan & billing", href: "/settings/billing", icon: CreditCard },
];
